import Vue from 'vue'
import '@/views/components/self-select/index.js'
import ZhituIcon from '@/views/components/zhitu-icon';
import ImgBox from '@/views/components/img-box';
import ScrollBox from '@/components/scroll-box';

Vue.component('ZhituIcon', ZhituIcon);
Vue.component('ImgBox', ImgBox);
Vue.component('ScrollBox', ScrollBox);
